<div class="empty-list">
  <img class="icon-search" src="/assets/img/empty-list-search.svg" alt="">

  <div class="empty-list__content">
    <span class="empty-list__content__title">
      {{ 'integrationEmptyList' | translate }} „{{ title }}”
    </span>
    <span class="empty-list__content__description">
      {{ 'integrationEmptyDescription' | translate }}
    </span>

    <p-button (onClick)="onClickSubmit$.emit()" class="submit" label="{{ 'integrationEmptySubmit' | translate }}" />
  </div>
</div>
